import React, { FC } from 'react';

import { Node } from 'src/common/interfaces/node.interface';

interface PlayerNavigationDesktopTopProps {
  currentNode: Node;
}

export const PlayerNavigationDesktopTop: FC<PlayerNavigationDesktopTopProps> = ({ currentNode }) => {
  if (!currentNode) return null;
  if (currentNode.content_type === 'journey_upsell') return null;

  return (
    <div className='hidden md:block flex-shrink-0 text-bedrock-h1 text-bedrock-black truncate'>{currentNode.name}</div>
  );
};
